var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featuresSlider"},[_c('vueper-slides',{attrs:{"autoplay":"","fade":"","bullets-outside":"","slideRatio":1100/1600}},_vm._l((_vm.slides),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide.image,"title":slide.title}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }